import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CurvaAbcVendaTableModule } from '../../table';
import { TipoClassificacaoSelectModule } from '../../../../tipo-classificacao/select';

import { CurvaAbcVendaPerspectivaContentComponent } from './curva-abc-venda-perspectiva-content.component';

@NgModule({
    imports: [
        SharedModule,
        CurvaAbcVendaTableModule,
        TipoClassificacaoSelectModule
    ],
    declarations: [
        CurvaAbcVendaPerspectivaContentComponent
    ],
    exports: [
        CurvaAbcVendaPerspectivaContentComponent
    ]
})
export class CurvaAbcVendaPerspectivaContentModule {}
